import {PERSONALITY_FACTOR_MESSAGES, PersonalityFactorKey} from '../../constants';

export function getFactorMessages(factor: PersonalityFactorKey) {
    return PERSONALITY_FACTOR_MESSAGES[factor];
}
